import { render, staticRenderFns } from "./serveSystem.vue?vue&type=template&id=62d0d1f8&scoped=true&"
import script from "./serveSystem.vue?vue&type=script&lang=js&"
export * from "./serveSystem.vue?vue&type=script&lang=js&"
import style0 from "./serveSystem.vue?vue&type=style&index=0&id=62d0d1f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d0d1f8",
  null
  
)

export default component.exports